import { useSetAuthState } from '../state/auth'
import { useTenantContext } from '@/context/tenant'
import api from '@/lib/api'
import { getCleanDomain } from '@/utils/getCleanDomain'
import { AuthAPI } from '@/types/auth'
import convertAuthUser from '../helpers/convertAuthUser'
import domainConfigs, { DomainConfig } from '@/config/domain'

export default function useSignIn() {
  const setAuth = useSetAuthState()
  const { setCurrentTenant } = useTenantContext()

  const signIn = async (email: string, password: string) => {
    const hostname = window.location.hostname // captura "localhost"
    const domain = getCleanDomain() // normalmente seu domínio limpo
    const response = await api.post<AuthAPI>('/auth/login', { email, password })
    const authResponse = convertAuthUser(response.data)
    const { user } = authResponse

    if (!user) {
      throw new Error('Usuário não encontrado')
    }

    // nova lógica: em localhost, busca config pelo user.id_tenant; senão, pelo domínio
    let tenantConfig: DomainConfig | undefined
    if (hostname === 'localhost') {
      tenantConfig = Object.values(domainConfigs).find(cfg => cfg.id === user.id_tenant)
    } else {
      tenantConfig = domainConfigs[domain]
    }

    if (!tenantConfig) {
      throw new Error(
        hostname === 'localhost'
          ? `Nenhuma configuração de domínio coincide com o tenant id ${user.id_tenant}`
          : `Configuração de domínio não encontrada para ${domain}`
      )
    }

    // mantém sua checagem extra de segurança
    if (tenantConfig.id !== user.id_tenant) {
      throw new Error(`Usuário não vinculado a empresa ${tenantConfig.title}!`)
    }

    if (user.isAccepted === false) {
      throw new Error('Usuário não aceito')
    }

    setAuth(authResponse)
    setCurrentTenant(tenantConfig as any)
    return user
  }

  return { signIn }
}
